import {CreateElement} from "../../Utilities/CreateElement";

export class TaskbarEntry {
    dom: HTMLElement;

    constructor(widget: HTMLElement) {
        this.dom = widget;
    }

    render(container: HTMLElement) {
        container.appendChild(this.dom);
    }
}

export class TaskbarMenuEntry extends TaskbarEntry {
    widget: HTMLElement;
    menu: HTMLElement;

    constructor(widget: HTMLElement) {
        super(CreateElement(`<div class="dropdown-center"></div>`));
        this.widget = widget;
        // this.widget.classList.add("dropdown-toggle");
        this.widget.setAttribute("data-bs-toggle", "dropdown");
        this.dom.appendChild(this.widget);


        this.menu = CreateElement(`<ul class="dropdown-menu"></ul>`);
        this.dom.appendChild(this.menu);
    }

    addMenuItem(widget: HTMLElement, action: () => void) {
        const item = CreateElement(`<li class="dropdown-item"></li>`);
        item.addEventListener('click', () => action());
        item.appendChild(widget);
        this.menu.appendChild(item);
    }


}

export class TaskbarMenuEntryIconButton extends TaskbarMenuEntry {
    constructor(icon: string, label: string | undefined = undefined) {
        super(CreateElement(`<button class="btn border-0" type="button"><i class="bi ${icon}"></i>${label !== undefined ? " " + label : ""}</button>`));
    }
}

export class TaskbarEntryIconButton extends TaskbarEntry {
    constructor(icon: string, label: string | undefined = undefined, action: () => void) {
        super(CreateElement(`<button class="btn border-0" type="button"><i class="bi ${icon}"></i>${label !== undefined ? " " + label : ""}</button>`));
        this.dom.addEventListener('click', action);
    }
}